import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card, CardBody } from 'reactstrap';
import Avatar from 'views/Widgets/People/Avatar';
import AvatarGroup from 'views/Widgets/People/AvatarGroup';
import type { CalibrationViewSummary } from '../types';

export interface CalibrationViewPeopleProps {
  selectedView?: CalibrationViewSummary;
}

/**
 * Card displaying view people (owner, administrators, reviewers)
 *
 * Shows:
 * - Owner person
 * - Administrator list with avatars
 * - Reviewer list with avatars
 *
 * @param props - Component props
 */
export const CalibrationViewPeople: React.FC<CalibrationViewPeopleProps> = ({
  selectedView,
}) => {
  return (
    <Card className="mb-0 h-100 flex-fill">
      <CardBody className="pb-0" style={{ minHeight: '90px' }}>
        <div className="d-flex flex-wrap gap-4 align-items-start">
          <div className="d-flex flex-column gap-1">
            <span className="text-muted small fw-semibold">
              <FormattedMessage
                id="app.views.widgets.dashboards.calibration_dashboard.calibration_view_people.owner"
                defaultMessage="Owner"
              />
            </span>
            {selectedView?.ownerPerson ? (
              <Avatar size="xs" hidePopover person={selectedView.ownerPerson} />
            ) : (
              <span className="text-muted">
                <FormattedMessage
                  id="app.views.widgets.dashboards.calibration_dashboard.list.calibration_view_people.no_owner"
                  defaultMessage="No owner"
                />
              </span>
            )}
          </div>
          <div className="d-flex flex-column gap-1">
            <span className="text-muted small fw-semibold">
              <FormattedMessage
                id="app.views.widgets.dashboards.calibration_dashboard.calibration_view_people.administrators"
                defaultMessage="Administrators"
              />
            </span>
            {selectedView?.administrators?.length ? (
              <AvatarGroup size="xs" people={selectedView.administrators} />
            ) : (
              <span className="text-muted">
                <FormattedMessage
                  id="app.views.widgets.dashboards.calibration_dashboard.calibration_view_people.no_administrators"
                  defaultMessage="No administrators"
                />
              </span>
            )}
          </div>
          <div className="d-flex flex-column gap-1">
            <span className="text-muted small fw-semibold">
              <FormattedMessage
                id="app.views.widgets.dashboards.calibration_dashboard.calibration_view_people.reviewers"
                defaultMessage="Reviewers"
              />
            </span>
            {selectedView?.reviewers?.length ? (
              <AvatarGroup size="xs" people={selectedView.reviewers} />
            ) : (
              <span className="text-muted">
                <FormattedMessage
                  id="app.views.widgets.dashboards.calibration_dashboard.calibration_view_people.no_reviewers"
                  defaultMessage="No reviewers"
                />
              </span>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
